/**
 * Evidence-view edit-permission gate (EvidenceView.jsx `canEdit`), extracted to a
 * dependency-free module so it is unit-testable without mounting EvidenceView's antd /
 * AppContext / MSAL surface — mirrors the extraction pattern already used for
 * utils/workspaceStepRestore.js (see .claude/lessons/workspace-active-step-persist-desync.md
 * for why the full component isn't a viable test harness).
 *
 * This is the exact logic fixed at commit 09466d7 — see
 * .claude/lessons/frontend-role-comparison-casing-and-placeholder-id.md for the two stacked
 * bugs it replaced on `isAdvisor` (an uppercase `Role.ADVISOR` enum compared against the
 * lowercase DB role string on membership rows, and a bare `user.id` — a synthetic
 * `msal-{email}` placeholder set at sign-in, App.jsx — compared against a membership id
 * instead of the resolved `user.dbUserId`), plus a third, sibling bug on `isLeadAdvisor`
 * (a fragile display-name match, `activeProject.leadAdvisor === user?.name`, instead of an
 * id-based membership lookup).
 *
 * Mechanical, behavior-preserving extraction — no logic changed from the fixed lines in
 * EvidenceView.jsx.
 */
import { Role } from '../constants/roles';

export function getEvidenceEditPermissions(user, activeProject) {
    const currentUserId = user?.dbUserId || user?.id;
    const isLeadAdvisor =
        user?.role === Role.LEAD_ADVISOR &&
        activeProject?.members?.some((m) => m.id === currentUserId && m.role === 'lead_advisor');
    const isAdvisor =
        user?.role === Role.ADVISOR &&
        activeProject?.members?.some((m) => m.id === currentUserId && m.role === 'advisor');
    const canEdit = user?.role === Role.ADMIN || isLeadAdvisor || isAdvisor;
    return { isLeadAdvisor, isAdvisor, canEdit };
}
